import { createAction, props } from '@ngrx/store';

import * as models from '../../domain/models';

export const load = createAction('[Charter.OpportunityStatusCollection] Load');
export const loadSuccess = createAction(
  '[Charter.OpportunityStatusCollection] Load Success',
  props<{ payload: Array<models.OpportunityStatus> }>()
);
export const loadFail = createAction('[Charter.OpportunityStatusCollection] Load Fail');
